export default __webpack_public_path__ + "static/media/Background5.0f8cd4a3.png";